import { render, staticRenderFns } from "./IconChild.vue?vue&type=template&id=d9162f50&"
import script from "./IconChild.vue?vue&type=script&lang=js&"
export * from "./IconChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports